import { AdditionalInfoImpl } from './additional-info-impl';
import { Expose, Type } from 'class-transformer';

export class LcdStatus extends AdditionalInfoImpl {

  address: string;

  @Type(() => Date)
  time: Date;

  @Type(() => LCDDisplayStatus)
  lcdStatuses: LCDDisplayStatus[];

  getVersions(): string {
    if (this.lcdStatuses == null || this.lcdStatuses.length == 0)
      return '-';
    else {
      let ver = '';
      const tmp = [];
      for (const displayStatus of this.lcdStatuses) {
        if (tmp.indexOf(displayStatus.version) == -1) {
          ver += displayStatus.version + ' / ';
          tmp.push(displayStatus.version);
        }
      }
      if (ver.endsWith(' / '))
        ver = ver.substring(0, ver.length - 3);
      return ver;
    }
  }
}

export class LCDDisplayStatus {

  key: string;

  dip: number;

  @Expose({ name: 'service_mode' })
  serviceMode: boolean;

  status: string[];

  version: string;
}
